var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('details',[_c('summary',{staticClass:"pointer",class:_vm.noselect ? 'noselect' : ''},[_vm._v(_vm._s(_vm.summary))]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }